import React, { memo, useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import GoldenOfferComponent from '../GoldenOfferComponent/GoldenOfferComponent'
import './GoldenOfferSlider.css'
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Autoplay } from "swiper";
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration';

function GoldenOfferSlider() {
  const [specialDiscountList, setSpecialDicountList] = useState();
  let currentDate = new Date();

  useEffect(() => {
    axiosConfig.get("api/discount").then((res) => {
      setSpecialDicountList(res.data)
    })
  }, [])
  return (
    <>
      <div className='golden-offer-slider'>
        <Container>
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className="mySwiper"
          >
            {
              specialDiscountList?.filter(p => p.course != null && new Date(p.startTime).getTime() >= currentDate.getTime()
                && new Date(p.startTime).getTime() <= currentDate.setDate(currentDate.getDate() + parseInt(p.duration))).map((item) => (
                  <SwiperSlide key={item.id}><GoldenOfferComponent item={item} /></SwiperSlide>
                ))
            }
          </Swiper>
        </Container>
      </div>
      <div className='goldenoffer-background'>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0  0 1000 100" preserveAspectRatio="none" style={{}}><path className="elementor-shape-fill" d="M761.9,44.1L643.1,27.2L333.8,98L0,3.8V0l1000,0v3.9"></path></svg>
      </div>
    </>

  )
}
export default memo(GoldenOfferSlider)